import CONSTANT from '../../constants'
import fetchWithAuthorizationHeader from '../../helper/fetchWithAuthorizationHeader'

const { MULTI_TENANT_REQUESTS_API_URL } = CONSTANT

const getSingleMultiTenantRequest = async (
	multiTenantRequestID: string
): Promise<{ status: number; body: object | Array<object> }> => {
	const response = await fetchWithAuthorizationHeader(
		`${MULTI_TENANT_REQUESTS_API_URL}?multiTenantRequestID=${multiTenantRequestID}`
	)
	return response.json()
}

export default getSingleMultiTenantRequest
